const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "QUEM SOMOS",
    to: "/quem-somos",
  },
  {
    text: "PRODUTOS",
    to: "/produtos",
  },
  {
    text: "PARCEIROS",
    to: "/parceiros",
  },
  {
    text: "FALE CONOSCO",
    to: "/fale-conosco",
  },
];

export { server, menu };
